<template >
  <v-container :key="refresh" id="certification-container">
    <Title title="Certification Details"></Title>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>
    <v-row>
      <v-col lg="12" class="pb-0">
        <h2 style="display: inline-block">Certification</h2>
        <v-btn
          v-if="
            ($store.state.role == 'master' || $store.state.role == 'ao') &&
            status != 'approved'
          "
          tile
          style="float: right"
          color="#6490f1"
          dark
          class="mb-2 ml-3"
          @click="onApproveCertification()"
        >
          <v-icon size="20" class="mr-1">mdi-check</v-icon>Approve
        </v-btn>
        <v-btn
          v-if="
            ($store.state.role == 'master' || $store.state.role == 'ao') &&
            status != 'approved'
          "
          tile
          style="float: right"
          color="#EF5350"
          dark
          class="mb-2 ml-3"
          @click="onDeleteCertification()"
        >
          <v-icon size="20" class="mr-1">mdi-delete</v-icon>Delete
        </v-btn>
        <v-btn
          v-if="
            ($store.state.role == 'master' || $store.state.role == 'ao') &&
            status == 'approved'
          "
          tile
          style="float: right"
          color="primary"
          class="mb-2 ml-3"
          :disabled="!isInvoiceRisen"
          @click="onPrintCertification()"
          >Print Certificate</v-btn
        >
        <v-btn
          v-if="
            ($store.state.role == 'master' || $store.state.role == 'ao') &&
            status == 'approved' &&
            !isInvoiceRisen
          "
          tile
          style="float: right"
          color="primary"
          class="mb-2 ml-3"
          @click="onInvoiceRaised()"
          >Mark invoice as raised</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="12" class="pb-0">
        <CertificationSummary @certificationStatus="getCertificationStatus" />
      </v-col>
    </v-row>

    <v-divider
      class="mb-5"
      style="border-color: rgba(160, 160, 160, 0.25); border-width: 1px"
    ></v-divider>

    <v-col lg="12" class="pa-0">
      <v-row>
        <v-col md="12">
          <h3>
            Qualification: {{ qualificationName }} ({{ qualificationCode }})
          </h3>
        </v-col>
        <v-col md="4" v-for="assessment in assessments" :key="assessment._id">
          <v-card class="mx-auto py-1 asessment-card">
            <v-list-item three-line class="ml-0">
              <v-list-item-content class="pb-5">
                <v-list-item-title
                  style="font-size: 1.3rem"
                  :title="assessment.unit.name"
                  class="mb-4"
                  >{{ assessment.unit.code }}:
                  {{ assessment.unit.name }}</v-list-item-title
                >
                <v-list-item-subtitle class="mb-3 card-subtitle-text">
                  Grade: {{ assessment.grade }}, Type:
                  {{
                    assessment.type.charAt(0).toUpperCase() +
                    assessment.type.slice(1)
                  }}
                </v-list-item-subtitle>

                <span style="text-decoration: underline; font-size: 0.9rem">
                  Assessments
                  <span v-if="assessment.moderationRequested">(Required)</span>
                </span>
                <span v-if="assessment.uploads.length > 0">
                  <p
                    v-for="(upload, index) in assessment.uploads"
                    :key="upload.name"
                    class="pt-2"
                    style="font-size: 0.9rem"
                  >
                    {{ index + 1 }}.
                    <span v-if="assessment.uploads.length > 0">
                      <strong>{{ upload.name }}</strong>
                    </span>
                    <a
                      class="float-right"
                      @click="onRemoveAssessment(assessment._id, upload._id)"
                      style="text-decoration: underline"
                      >Remove</a
                    >
                    <a
                      class="px-2 float-right"
                      style="text-decoration: underline"
                      @click="onDownlaodAssessment(upload.filePath)"
                      >Download</a
                    >
                  </p>
                </span>
                <span v-else><p>-</p></span>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions v-if="status != 'approved'">
              <v-btn
                style="background-color: rgba(179, 212, 252, 0.2)"
                v-if="
                  $store.state.role == 'ao' && !assessment.moderationRequested
                "
                color="primary"
                text
                tile
                @click="onRequestModeration(assessment._id)"
                >Request Moderation</v-btn
              >
              <v-btn
                v-if="
                  $store.state.role == 'ao' && assessment.moderationRequested
                "
                color="primary"
                disabled
                text
                tile
                @click="onRequestModeration(assessment._id)"
                >Moderation request sent</v-btn
              >
              <input
                id="fileUpload"
                type="file"
                hidden
                @change="onAddFile($event)"
              />
              <v-btn
                style="background-color: rgba(179, 212, 252, 0.2)"
                v-if="
                  $store.state.role == 'centre' &&
                  (assessment.moderationRequested ||
                    assessment.uploads.length > 0)
                "
                color="primary"
                text
                tile
                @click="onUploadAssessment(assessment._id)"
              >
                <span v-if="assessment.uploads.length > 0"
                  >Upload more assessment</span
                >
                <span v-else>Upload assessment</span>
              </v-btn>
              <v-btn
                v-else
                color="primary"
                disabled
                text
                tile
                @click="onUploadAssessment()"
              ></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import CertificationSummary from "../components/CertificationSummary";
import Title from "../components/Title";

export default {
  components: {
    CertificationSummary,
    Title,
  },
  data: function () {
    return {
      interval: {},
      value: 0,
      max: 80,
      status: null,
      isInvoiceRisen: null,
      currentAssessmentId: null,
      refresh: false,
      snackbar: false,
      snackbarText: "",
      assessments: [],
      moderationRequest: [],
      qualificationCode: "",
      qualificationName: "",
    };
  },
  methods: {
    onPrintCertification: function () {
      fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}/print?learnerId=${this.$route.query.learnerId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      )
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          window.open(url);
          URL.revokeObjectURL(url);
        })
        .catch((err) => console.log(err));
    },
    onInvoiceRaised: function () {
      // send patch request to make isInvoiceRisen  = true
      fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({
            isInvoiceRisen: true,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.snackbarText = data.message;
          this.snackbar = true;
          this.status = "approved";
        })
        .catch((error) => {
          console.error(error);
        });

      this.isInvoiceRisen = true;
    },
    onApproveCertification: function () {
      fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({
            status: "approved",
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.snackbarText = data.message;
          this.snackbar = true;
          this.status = "approved";
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onRequestModeration: function (assessmentId) {
      this.moderationRequest.push(assessmentId);

      fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({
            status: "moderation",
            moderationRequest: this.moderationRequest,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.refresh = !this.refresh;
          this.snackbarText = data.message;
          this.snackbar = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCertificationStatus: function (data) {
      this.status = data.status;
      this.assessments = data.assessments;
      this.isInvoiceRisen = data.isInvoiceRisen;
      this.qualificationCode = data.qualification.code;
      this.qualificationName = data.qualification.name;
    },
    onUploadAssessment: function (assessmentId) {
      this.currentAssessmentId = assessmentId;
      document.getElementById("fileUpload").click();
    },
    onAddFile: function (event) {
      const fileName = prompt(
        "Give the file a name",
        event.target.files[0].name.split(".")[0]
      );

      if (!fileName) {
        return;
      }

      const formData = new FormData();
      formData.append("resources", event.target.files[0]);
      formData.append("fileName", fileName);
      // formData.append("filePath", event.target.files[0].name);
      formData.append("id", this.currentAssessmentId);
      formData.append("moderationRequested", false);
      formData.append("certificationId", this.$route.query.id);

      fetch(`${process.env.VUE_APP_ROOT_API}/assessments/resources`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          this.refresh = !this.refresh;
          this.snackbarText = data.message;
          this.snackbar = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onDownlaodAssessment: function (filePath) {
      fetch(
        `${process.env.VUE_APP_ROOT_API}/assessments/download?file=${filePath}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      )
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = filePath; // the filename you want
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);

          this.snackbarText = "Downloading file ...";
          this.snackbar = true;
        })
        .catch((err) => {
          if (err) {
            this.snackbarText = "File is no longer available";
            this.snackbar = true;
            return;
          }
          console.log(err);
        });
    },
    onRemoveAssessment: async function (assessmentId, uploadId) {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/assessments/${assessmentId}/uploads?uploadId=${uploadId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          method: "PATCH",
        }
      );
      const data = await response.json();

      this.snackbarText = data.message;
      this.snackbar = true;
      this.refresh = !this.refresh;
    },
    onDeleteCertification: async function () {
      const confirm = window.confirm(
        "Are you sure you want to delete this certification?"
      );

      if (!confirm) return;

      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          method: "DELETE",
        }
      );

      await response.json();
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>
#certification-container {
  min-height: 100vh;
}

.asessment-card {
  border: 1px solid rgba(200, 200, 200, 0.5);
  box-shadow: none;
}

.card-subtitle-text {
  font-size: 0.9rem;
}
</style>

